import GalleryIconPng from "../assets/booths/Gallery.png";
import LockerRoomPng from "../assets/booths/Locker Room.png";
import TeamsPng from "../assets/booths/Team.png";
import StaffPng from "../assets/booths/Staff.png";
import MemoriabiliaPng from "../assets/booths/Memoriabilia.png";
import TicketsPng from "../assets/booths/Tickets.png";
import ClubPng from "../assets/booths/Club.png";
import NewsPng from "../assets/booths/News.png";
import ShopPng from "../assets/booths/Shop.png";
import PartnersPng from "../assets/booths/Partners.png";
import HallofFamePng from "../assets/booths/Hall of Fame.png";
import SeasonPng from "../assets/booths/Season.png";
import HospitalityPng from "../assets/booths/Hospitality.png";
import TrophyRoomPng from "../assets/booths/Trophy Room.png";
import TifoXRDefault from "../assets/booths/TifoXR Isotop.png";
import CharitiesPng from "../assets/icons/charities.png";
import RecognitionPng from "../assets/icons/recognition.png";
import EventsPng from "../assets/icons/events.png";
import CityPng from "../assets/booths/City.png";
import StadiumPng from "../assets/booths/Stadium.png";
import ContactUsPng from "../assets/booths/Contact Us.png";
import LoungePng from "../assets/booths/Lounge.png";
// QPR-only icons — selectable only for space id 11 (see QPR_ONLY_ICON_OPTIONS below).
import CommunityTrustPng from "../assets/booths/Community Trust.png";
import FixturesPng from "../assets/booths/Fixtures.png";
import ForeverRsPng from "../assets/booths/Forever Rs.png";
import JuniorHoopsPng from "../assets/booths/Junior Hoops.png";
import LegacyNumberPng from "../assets/booths/Legacy Number.png";
import QprPlusPng from "../assets/booths/QPR+.png";
import VisitPng from "../assets/booths/Visit.png";
import LegendsOfTheLoftPng from "../assets/booths/Legends Of The Loft.png";

export const IconMap = {
  bth_gallery: GalleryIconPng,
  bth_locker_room: LockerRoomPng,
  bth_teams: TeamsPng,
  bth_staff: StaffPng,
  bth_memorabilia: MemoriabiliaPng,
  bth_tickets: TicketsPng,
  bth_club: ClubPng,
  bth_news: NewsPng,
  bth_shop: ShopPng,
  bth_city: CityPng,
  bth_stadium: StadiumPng,
  bth_contact_us: ContactUsPng,
  bth_lounge: LoungePng,
  bth_partners: PartnersPng,
  bth_hall_of_fame: HallofFamePng,
  bth_season: SeasonPng,
  bth_hospitality: HospitalityPng,
  bth_trophy_room: TrophyRoomPng,
  bth_charity: CharitiesPng,
  bth_charities: CharitiesPng,
  bth_recognition: RecognitionPng,
  bth_events: EventsPng,
  btn_tt1_gallery: GalleryIconPng,
  btn_tt1_locker_room: LockerRoomPng,
  btn_tt1_teams: TeamsPng,
  btn_tt1_staff: StaffPng,
  btn_tt1_memorabilia: MemoriabiliaPng,
  btn_tt1_tickets: TicketsPng,
  btn_tt1_club: ClubPng,
  btn_tt1_news: NewsPng,
  btn_tt1_shop: ShopPng,
  btn_tt1_partners: PartnersPng,
  btn_tt1_hall_of_fame: HallofFamePng,
  btn_tt1_season: SeasonPng,
  btn_tt1_hospitality: HospitalityPng,
  btn_tt1_trophy_room: TrophyRoomPng,
  btn_tt1_charity: CharitiesPng,
  btn_tt1_charities: CharitiesPng,
  btn_tt1_recognition: RecognitionPng,
  btn_tt1_events: EventsPng,
  btn_tt1_city: CityPng,
  btn_tt1_stadium: StadiumPng,
  btn_tt1_contact_us: ContactUsPng,
  btn_tt1_lounge: LoungePng,
  btn_tt1_default: TifoXRDefault,

  // QPR-only icons (space id 11) — same dual-prefix pattern as every icon above.
  bth_community_trust: CommunityTrustPng,
  bth_fixtures: FixturesPng,
  bth_forever_rs: ForeverRsPng,
  bth_junior_hoops: JuniorHoopsPng,
  bth_legacy_number: LegacyNumberPng,
  bth_qpr_plus: QprPlusPng,
  bth_visit: VisitPng,
  bth_legends_of_the_loft: LegendsOfTheLoftPng,
  btn_tt1_community_trust: CommunityTrustPng,
  btn_tt1_fixtures: FixturesPng,
  btn_tt1_forever_rs: ForeverRsPng,
  btn_tt1_junior_hoops: JuniorHoopsPng,
  btn_tt1_legacy_number: LegacyNumberPng,
  btn_tt1_qpr_plus: QprPlusPng,
  btn_tt1_visit: VisitPng,
  btn_tt1_legends_of_the_loft: LegendsOfTheLoftPng,
};

// Looks up an icon by the booth/button's English display name.
// localizedPairs.key is a UUID in the DB, so we derive the icon key from the name text.
// e.g. "Locker Room" → "bth_locker_room", "Hall of Fame" → "bth_hall_of_fame"
export const getBoothIcon = (localizedPairs, prefix = "bth") => {
  const enValue = localizedPairs?.values?.find(
    (v) => v.localeId === "en_us" || v.localeId === "en"
  )?.value ?? localizedPairs?.values?.[0]?.value;

  if (!enValue) return TifoXRDefault;

  const key = `${prefix}_${enValue.toLowerCase().replace(/\s+/g, "_")}`;
  return IconMap[key] ?? TifoXRDefault;
};

// The 21 icons a user can actually pick in the icon picker — one canonical bare key per
// underlying image (IconMap has both a "bth_" and "btn_tt1_" entry per icon, and two
// synonym keys — "bth_charity"/"bth_charities" — for the same image; only one of each is
// listed here as a selectable option).
export const BOOTH_ICON_OPTIONS = [
  { key: "gallery",      label: "Gallery" },
  { key: "locker_room",  label: "Locker Room" },
  { key: "teams",        label: "Team" },
  { key: "staff",        label: "Staff" },
  { key: "memorabilia",  label: "Memorabilia" },
  { key: "tickets",      label: "Tickets" },
  { key: "club",         label: "Club" },
  { key: "news",         label: "News" },
  { key: "shop",         label: "Shop" },
  { key: "city",         label: "City" },
  { key: "stadium",      label: "Stadium" },
  { key: "contact_us",   label: "Contact Us" },
  { key: "lounge",       label: "Lounge" },
  { key: "partners",     label: "Partners" },
  { key: "hall_of_fame", label: "Hall of Fame" },
  { key: "season",       label: "Season" },
  { key: "hospitality",  label: "Hospitality" },
  { key: "trophy_room",  label: "Trophy Room" },
  { key: "charities",    label: "Charities" },
  { key: "recognition",  label: "Recognition" },
  { key: "events",       label: "Events" },
];

// Additional icons offered only for space id 11 (QPR) — see IconPickerModal.jsx, which
// appends these to BOOTH_ICON_OPTIONS only when the active space is QPR.
export const QPR_ONLY_ICON_OPTIONS = [
  { key: "community_trust",      label: "Community Trust" },
  { key: "fixtures",             label: "Fixtures" },
  { key: "forever_rs",           label: "Forever Rs" },
  { key: "junior_hoops",         label: "Junior Hoops" },
  { key: "legacy_number",        label: "Legacy Number" },
  { key: "qpr_plus",             label: "QPR+" },
  { key: "visit",                label: "Visit" },
  { key: "legends_of_the_loft",  label: "Legends Of The Loft" },
];

// Resolves a booth's display icon: an explicitly picked iconKey first, falling back to the
// same name-derivation getBoothIcon() has always done (and further down to the default) when
// there's no explicit pick, or the pick is stale/unrecognized. This is the fallback chain to
// use everywhere a booth's icon is rendered — it never changes what already-existing booths
// (no iconKey set) show today.
export const resolveBoothIcon = (booth, prefix = "bth") => {
  if (booth?.iconKey) {
    const mapped = IconMap[`${prefix}_${booth.iconKey}`];
    if (mapped) return mapped;
  }
  return getBoothIcon(booth?.localizedPairs, prefix);
};

